import React from 'react'
import { Route, Switch } from 'react-router-dom'
import Home from '../components/Home'
import GetStarted from '../components/GetStarted'
import Header from '../containers/Header'
import AuthCode from '../containers/AuthCode'
import Cookies from 'universal-cookie'
import { refreshToken } from '../reducers/asciidoc/Auth/action'
import Validation from '../components/Validation'
import BulkApiDocumentation from '../scenes/BulkApiDocumentation/BulkApiDocumentation'
import { isPathMatched } from '../../util/urlUtil'
import GetStartedV2 from "../scenes/GetStarted/GetStartedV2";
import Catalog from "../scenes/Catalog/Catalog";
import Overview from "../scenes/Catalog/Overview";
import Support from "../scenes/Support/Support";

const cookies = new Cookies();

const isConnected = cookies.get('isConnected');

refreshToken();

const routes = (
  <div>
    {isPathMatched('validation') ? <div></div> : <Header connected={isConnected} />}
    <Switch>
      <Route
        exact path="/"
        render={() => <Home value={0} />}
      />
      <Route
        exact path="/get-started"
        render={() => <GetStarted value={1} connected={isConnected} />}
      />
      <Route
          exact path="/get-started-v2"
          render={() => <GetStartedV2 />}
      />
      <Route
          exact path="/catalog"
          render={() => <Catalog />}
      />
      <Route
          exact path="/overview"
          render={() => <Overview />}
      />
      <Route
          exact path="/support"
          render={() => <Support />}
      />
      <Route
        exact path="/auth"
        render={() => <AuthCode connected={isConnected} />}
      />
      <Route path="/api" component={GetStarted} value={5} />
      <Route path="/apps" component={GetStarted} value={6} />
      <Route path="/validation" component={Validation} />
      <Route
        exact path="/bulk-api/documentation"
        render={() => <BulkApiDocumentation />}
      />
    </Switch>
  </div>
)

export default routes
